module.exports = __webpack_public_path__ + "assets/72a39bd0e125737b45dec0744fe5f5ef.jpg";